module.exports = __webpack_public_path__ + "84cd5cb9df85e833c1e24efe0b3735ba.png";